routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.proceedingsList', {
      url: "/consultas/actas",
      template: `<proceedings-list sh-ctrl="shCtrl"></proceedings-list>`,
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/proceedings-list/proceedings-list.config.js
 **/